import { useGetMyApprovalsQuery, ApprovalRequest } from '../../../services/ApprovalService';
import { InboxFilter } from '../components/ApprovalStatusFilter';

// Pending tab polls every 60s so the inbox stays fresh; history tabs are static
// until the user toggles back. RTK Query caches per (scope, status) tuple so
// re-selecting a tab is instant.
export function useApprovalInbox(filter: InboxFilter) {
  const query = useGetMyApprovalsQuery(
    { scope: 'mine', status: filter },
    { pollingInterval: filter === 'pending' ? 60_000 : 0 }
  );

  const rows: ApprovalRequest[] = query.data ?? [];
  return {
    rows,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    refetch: query.refetch,
  };
}
